import { useState } from "react";
import { Grid, Num, Pick, card, fmt, sig } from "./ui";

const KINDS = {
  length: { label: "Length", units: { mm: 1, cm: 10, m: 1000, in: 25.4, ft: 304.8, yd: 914.4, pt: 25.4 / 72, pica: 25.4 / 6 }, from: "in", to: "mm" },
  area: { label: "Area", units: { "sq mm": 1, "sq cm": 100, "sq m": 1e6, "sq in": 645.16, "sq ft": 92903.04 }, from: "sq in", to: "sq cm" },
  weight: { label: "Weight", units: { g: 1, kg: 1000, tonne: 1e6, lb: 453.59237, oz: 28.349523 }, from: "lb", to: "kg" },
  thickness: { label: "Thickness / caliper", units: { micron: 1, mm: 1000, mil: 25.4, "pt (1/1000 in)": 25.4, "gauge (film)": 0.254 }, from: "mil", to: "micron" },
  volume: { label: "Volume", units: { ml: 1, l: 1000, "cu cm": 1, "cu m": 1e6, "cu in": 16.387064, "US gal": 3785.411784 }, from: "l", to: "ml" },
};
const TEMP = ["°C", "°F", "K"];
const toC = (v, u) => (u === "°C" ? v : u === "°F" ? (v - 32) * 5 / 9 : v - 273.15);
const fromC = (c, u) => (u === "°C" ? c : u === "°F" ? c * 9 / 5 + 32 : c + 273.15);

function Row({ kind }) {
  const k = KINDS[kind];
  const [v, setV] = useState(1);
  const [from, setFrom] = useState(k.from);
  const [to, setTo] = useState(k.to);
  const out = (Number(v) || 0) * k.units[from] / k.units[to];
  const opts = Object.keys(k.units);
  return (
    <div data-testid={`conv-${kind}`} style={card}>
      <b style={{ fontSize: 13 }}>{k.label}</b>
      <div style={{ marginTop: 10 }}><Grid min={120}>
        <Num testid={`conv-${kind}-value`} label="Value" value={v} onChange={setV}/>
        <Pick testid={`conv-${kind}-from`} label="From" value={from} onChange={setFrom} options={opts}/>
        <Pick testid={`conv-${kind}-to`} label="To" value={to} onChange={setTo} options={opts}/>
      </Grid></div>
      <div data-testid={`conv-${kind}-result`} style={{ marginTop: 10, fontSize: 18, fontWeight: 800 }}>{sig(Number(v) || 0)} {from} = {sig(out)} {to}</div>
      <div style={{ fontSize: 11.5, color: "#64748b", marginTop: 4 }}>{opts.filter(u => u !== from).slice(0, 5).map(u => `${sig((Number(v) || 0) * k.units[from] / k.units[u])} ${u}`).join(" · ")}</div>
    </div>
  );
}

function Temp() {
  const [v, setV] = useState(25);
  const [from, setFrom] = useState("°C");
  const c = toC(Number(v) || 0, from);
  return (
    <div data-testid="conv-temp" style={card}>
      <b style={{ fontSize: 13 }}>Temperature</b>
      <div style={{ marginTop: 10 }}><Grid min={120}>
        <Num testid="conv-temp-value" label="Value" value={v} onChange={setV} min={-1000}/>
        <Pick testid="conv-temp-from" label="From" value={from} onChange={setFrom} options={TEMP}/>
      </Grid></div>
      <div data-testid="conv-temp-result" style={{ marginTop: 10, fontSize: 15, fontWeight: 800 }}>{TEMP.filter(u => u !== from).map(u => `${fmt(fromC(c, u), 2)} ${u}`).join(" · ")}</div>
    </div>
  );
}

export function ConverterTool() {
  return (
    <div data-testid="tool-converter" style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))", gap: 16 }}>
      {Object.keys(KINDS).map(k => <Row key={k} kind={k}/>)}
      <Temp/>
    </div>
  );
}
